import React from "react";

export default (props: React.SVGAttributes<SVGElement>) => <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path fillRule="evenodd" clipRule="evenodd" d="M0 9C0 4.03749 4.03749 0 9 0C13.9625 0 18 4.03749 18 9C18 13.9625 13.9625 18 9 18C4.03749 18 0 13.9625 0 9ZM1.12501 8.99999C1.12501 13.3423 4.65765 16.875 9 16.875C13.3424 16.875 16.875 13.3423 16.875 8.99999C16.875 4.65764 13.3424 1.125 9 1.125C4.65765 1.125 1.12501 4.65764 1.12501 8.99999Z" fill="black"/>
<path d="M10.038 4H9V9.61L12.2661 13L13 12.2382L10.038 9.1639V4Z" fill="black"/>
</svg>
;
